module.exports = __webpack_public_path__ + "static/media/wxgraph_output_2.cc20b1b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WxGraphTool/wxgraph_output_2.png
// module id = 1775
// module chunks = 0